import { useRef, useState } from 'react';

import { Button } from '@playbooks/ui/components/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from '@playbooks/ui/components/dropdown-menu';
import { Icon } from '@playbooks/ui/components/icon';

const ComposerPlanAction = ({ disabled = false, planMode = false, onPlanModeChange }) => {
	const [open, setOpen] = useState(false);
	const ref = useRef(null);

	// Computed
	const label = planMode ? 'Plan' : 'Build';

	// Actions
	const onSelect = value => {
		onPlanModeChange?.(value === 'plan');
		setOpen(false);
	};

	// Methods
	const onClose = () => setOpen(false);
	const onToggle = () => setOpen(!open);

	// Render
	return (
		<DropdownMenu open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DropdownMenuTrigger
				render={
					<Button
						variant='outline'
						size='icon-xs'
						aria-label={`${label} mode`}
						data-active={open}
						disabled={disabled}
						onClick={onToggle}>
						<Icon data-icon='inline-start' type='far' icon={planMode ? 'lightbulb' : 'hammer'} aria-hidden />
					</Button>
				}
			/>
			<DropdownMenuContent align='start' side='bottom' className='min-w-40'>
				<DropdownMenuRadioGroup value={planMode ? 'plan' : 'build'} onValueChange={onSelect}>
					<DropdownMenuRadioItem value='plan' closeOnClick>
						<Icon type='far' icon='lightbulb' aria-hidden />
						Plan
					</DropdownMenuRadioItem>
					<DropdownMenuRadioItem value='build' closeOnClick>
						<Icon type='far' icon='hammer' aria-hidden />
						Build
					</DropdownMenuRadioItem>
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
export { ComposerPlanAction };
